const OrigemMensagem = {
  Recebida: 1,
  Enviada: 2
};

export default OrigemMensagem;
